/** @format */

export const KnowledgeBaseRating = ({ rating }) => {
  return (
    <div className="knowledge_base-widget--list-item-rating">
      {Array.from({ length: 5 }).map((_, index) => (
        <span key={index} className={index < Math.round(rating) ? 'rated' : ''}></span>
      ))}
    </div>
  );
};
